import axios from 'redaxios';
import { HOST } from '../constans/api';

export class ApiError extends Error {
    constructor(type, message, status) {
        super(message);
        this.type = type;
        this.status = status;
    }
}

function classifyError(error) {
    if (!error.status && !error.response) {
        return new ApiError('network', 'Network request failed', 0);
    }

    const status = error.status || error.response?.status;

    if (status === 404) {
        return new ApiError('not_found', 'Resource not found', 404);
    }

    return new ApiError('server', 'Server error', status || 500);
}

const http = axios.create({
    baseURL: HOST,
});

const originalGet = http.get.bind(http);
const originalPost = http.post.bind(http);

http.get = (...args) => originalGet(...args).catch(e => { throw classifyError(e); });
http.post = (...args) => originalPost(...args).catch(e => { throw classifyError(e); });

export { http }
